import { TFunction } from 'i18next';

const getTranslationOrItem = (t: TFunction, item: string, i18nKey: string): string => {
    const translation = t(i18nKey);
    return translation === i18nKey ? item : translation;
};

export default getTranslationOrItem;
